export default "__VITE_ASSET__6ebda704__"